import React, { useEffect, useState } from "react";
import Navigation from "./components/Navigation";
import PrivacyPolicy from "./components/PrivacyPolicy";
import UserDataProtection from "./components/UserDataProtection";

const TermCondition = () => {
  const [isNavVisible, setIsNavVisible] = useState(true);
  const [currentSection, setCurrentSection] = useState("Privacy Policy");

  useEffect(() => {
    window.scroll({
      behavior: "smooth",
      top: "0",
    });
  }, []);

  const scrollToSection = (sectionId, sectionName) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setCurrentSection(sectionName);
    }
  };

  return (
    <section className="term-condition-v2">
      <Navigation scrollToSection={scrollToSection} />

      <div className="term-condition-v2__content">
        <PrivacyPolicy />
        <UserDataProtection />
      </div>
    </section>
  );
};

export default TermCondition;
